import React from 'react';

export default function ImplBlock4Phases() {
  const phaseClass =
    'w-full min-[560px]:w-[48%] min-[900px]:w-[22%] flex flex-col items-start text-left';

  return (
    <section className="py-16 md:py-24 px-6 md:px-16 bg-paper border-t border-line">
      <div className="max-w-[1000px] mx-auto">
        <div className="mb-16 max-w-3xl">
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink mb-6 tracking-tight leading-[1.2]">
            De una población definida a una operación activa.
          </h2>
          <p className="text-[18px] md:text-[20px] text-ink-soft leading-[1.6]">
            El inicio se adapta a la realidad de cada red: puede utilizar integración, intercambio estructurado, cargas programadas o flujos asistidos.
          </p>
        </div>

        <div className="flex flex-wrap justify-between items-start gap-y-10 border-t border-line pt-12">
          
          {/* Phase 1 */}
          <div className={phaseClass}>
            <div className="text-[32px] font-bold text-ink-soft/30 mb-2 leading-none">01</div>
            <div className="text-[18px] font-bold text-ink mb-4">Definir</div>
            <ul className="space-y-2 text-[15px] text-ink-soft">
              <li>• Población</li>
              <li>• Objetivo operacional</li>
              <li>• Reglas autorizadas</li>
            </ul>
          </div>

          {/* Phase 2 */}
          <div className={phaseClass}>
            <div className="text-[32px] font-bold text-ink-soft/30 mb-2 leading-none">02</div>
            <div className="text-[18px] font-bold text-ink mb-4">Conectar</div>
            <ul className="space-y-2 text-[15px] text-ink-soft">
              <li>• Fuentes necesarias</li>
              <li>• Capacidad</li>
              <li>• Canales de ejecución</li>
            </ul>
          </div>

          {/* Phase 3 */}
          <div className={`${phaseClass} border-l-4 border-brand pl-4`}>
            <div className="text-[32px] font-bold text-brand mb-2 leading-none">03</div>
            <div className="text-[18px] font-bold text-brand mb-4">Operar</div>
            <ul className="space-y-2 text-[15px] text-ink">
              <li>• Trabajo priorizado</li>
              <li>• Coordinación</li>
              <li>• Espera Protegida</li>
              <li>• Excepciones</li>
            </ul>
          </div>

          {/* Phase 4 */}
          <div className={phaseClass}>
            <div className="text-[32px] font-bold text-ink-soft/30 mb-2 leading-none">04</div>
            <div className="text-[18px] font-bold text-ink mb-4">Medir y ajustar</div>
            <ul className="space-y-2 text-[15px] text-ink-soft">
              <li>• Resultados y Tiempos</li>
              <li>• Cuellos de botella</li>
              <li>• Capacidad / reglas</li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
}
